import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { xService } from 'src/services/x.service'


const useGetXRateLimits = () => {
  return useQuery(
    [QUERY_KEYS.X_RATE_LIMITS,],
    () => xService.getXRateLimits(),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 9000,
      refetchInterval: 10000

    },
  )
}

export { useGetXRateLimits }
